import { Popover } from "antd";
import { PrimaryButton } from "components/Button/ActionButton";
import { SupportedApp } from "config/config";
import { useAuth } from "hooks/useAuth";
import type { FC } from "react";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { AppDivider, AppLink, ContentWrapper, OpenButtonMenu } from "./userProfileStyles";

export type UserProfileProps = {
    apps: SupportedApp[];
};

export const UserProfile: FC<UserProfileProps> = ({ apps }: UserProfileProps) => {
    const { signOut } = useAuth();
    const navigate = useNavigate();

    const handleSignOut = useCallback(() => {
        signOut();
        navigate("/auth");
    }, [signOut, navigate]);

    const otherApps = apps.map((app) => <AppLink to={`/${app.name}`}>{app.title}</AppLink>);

    const content = (
        <ContentWrapper>
            {otherApps}
            <AppDivider />
            <PrimaryButton onClick={handleSignOut} data-name="sign_out_button">
                Sign Out
            </PrimaryButton>
        </ContentWrapper>
    );

    return (
        <Popover content={content} trigger="click" placement="bottomRight">
            <OpenButtonMenu role="button">&#8942;</OpenButtonMenu>
        </Popover>
    );
};
